import {allowUserScroll, preventUserScroll} from '../../services/preventUserScroll';
import {clickOnPremobileButton, closed, open} from '../../../events/header';
import {AWESOMEPLETE_CLOSE, AWESOMEPLETE_OPEN} from '../../../events/autocomplete';

const HEADER_WRAPPER_FIXED_CLASS = 'header-wrapper-fixed';
const HEADER_SEARCH_CLASSES = {
    opened: 'opened',
    invisible: HEADER_WRAPPER_FIXED_CLASS + '_invisible',
    focus: 'focused',
    formType: {
        search: 'FORM_SEARCH',
    },
};

const BODY_CLASSES = {
    noScroll: 'no-scroll',
};

const FORM_CLASS = {
    completed: 'completed',
    focus: 'focused',
    valid: 'valid',
};

Hop.defineModule('main-header-search', (domRoot, options) => {
    /**
     * Hop Module to handle Top Header menu and search forms.
     * @param {Element} domRoot - root Element
     * @param {Object} options - Optional params to configure bejaviors on this module
     * @param {boolean} options.openedByDefault - if true, always display the subheader, and show search form by default. (only for desktop)
     * @return {function} destroy - Destroy all Listeners.
     */

    const subheader = domRoot.querySelector('.js-header-subheader');
    const $searchInput = subheader.querySelector('#header_search-form__job-input');
    const domHeaderSearchBtn = domRoot.querySelectorAll('.js-search-btn');
    const domHeaderCloseSearch = domRoot.querySelector('[data-close-mobile-search]');
    const domMobileSearch = domRoot.hasAttribute('data-search-block-mobile');
    const webComponentTabs = subheader.querySelector('joy-tabs');

    const openedByDefault = options.openedByDefault;

    // Elements
    const backdrop = document.createElement('div');
    let showBackdrop = false;

    const MOBILE_SEARCH_BREAKPOINT = 1200;
    const PRE_MOBILE_MODE_BREAKPOINT = 1440;

    const debouncedOnResize = Hop.debounce(windowResizeListeners, 30);

    function windowResizeListeners() {
        hideSearchOnPreMobileMode('resize');
        hideMobileSearchOnResize();
    }

    function mediaHigherThanBreakpoint(minOrMax = 'min') {
        return matchMedia(`(${minOrMax}-width:${MOBILE_SEARCH_BREAKPOINT}px)`).matches;
    }

    function isPreMobileMode() {
        return matchMedia(`(max-width: ${PRE_MOBILE_MODE_BREAKPOINT}px)`).matches && matchMedia(`(min-width: ${MOBILE_SEARCH_BREAKPOINT}px)`).matches;
    }

    function hasToBeOpenedByDefault() {
        return openedByDefault && mediaHigherThanBreakpoint();
    }

    function resetInvalidFields() {
        if (Hop && Hop.formFn && Hop.formFn.removeSingleMessage) {
            Hop.formFn.removeSingleMessage('q2');
        }
    }

    function setSearchInvisible() {
        resetInvalidFields();
        domRoot.classList.remove(HEADER_SEARCH_CLASSES.opened);
        destroyBackdrop();
    }

    function setSearchVisible(withBackdrop = true) {
        domRoot.classList.add(HEADER_SEARCH_CLASSES.opened);
        if (withBackdrop && !showBackdrop) {
            initBackdrop();
        } else if (showBackdrop) {
            destroyBackdrop();
        }
        if (window.heap) {
            window.heap.track('openHeaderSubheader');
        }
    }

    function removeFocusClassOnJobInput() {
        $searchInput.classList.remove(FORM_CLASS.focus);
    }

    function setInputsAutompleteListener() {
        domRoot.addEventListener(AWESOMEPLETE_OPEN, addFocusClassOnJobInput);
        $searchInput.addEventListener(AWESOMEPLETE_CLOSE, removeFocusClassOnJobInput);
    }

    function addFocusClassOnJobInput() {
        if ($searchInput.nextSibling.childNodes.length) {
            $searchInput.classList.add(FORM_CLASS.focus);
        }
    }

    function focusJobInputSearch() {
        setTimeout(() => $searchInput.focus(), 200);
    }

    function openSearch(event) {
        const formType = event.target.dataset.formType;

        if (formType === 'search') {
            selectedTab('1');
            focusJobInputSearch();
        }

        const withBackdrop = !(hasToBeOpenedByDefault() && formType == 'search');

        setSearchInvisible();
        setSearchVisible(withBackdrop);
        activeButton(event);

        Hop.events.trigger(open);

        if (!mediaHigherThanBreakpoint()) {
            preventUserScroll();
        }

        domRoot.classList.add(HEADER_SEARCH_CLASSES.opened, HEADER_SEARCH_CLASSES.focus);

        if (!hasToBeOpenedByDefault()) {
            $searchInput.focus();
        }
    }

    function closeSearch(e) {
        if (e) {
            e.preventDefault();
        }

        setSearchInvisible();

        if (openedByDefault) {
            selectedTab('1');
        } else {
            desactiveAllButtons();
        }

        allowUserScroll();
        Hop.events.trigger(closed);
    }

    function selectedTab(value) {
        webComponentTabs.setAttribute('selected-tab', value);
    }

    function activeButton(event) {
        desactiveAllButtons();
        event.target.classList.add('active');
    }

    function desactiveAllButtons() {
        domHeaderSearchBtn.forEach((button) => {
            button.classList.remove('active');
        });
    }

    function hideSearchOnPreMobileMode(eventType) {
        // We need to check how this function is triggered
        // because on mobile, userScroll.prevent() triggers a window resize event. And this event triggers this function and finally hide the search
        if (eventType && eventType === 'resize') {
            return;
        }

        if (isPreMobileMode() || mediaHigherThanBreakpoint('max')) {
            setSearchInvisible();
        }
    }

    function hideMobileSearchOnResize() {
        if (mediaHigherThanBreakpoint('min') && domMobileSearch) {
            domRoot.classList.remove(HEADER_SEARCH_CLASSES.opened, HEADER_SEARCH_CLASSES.focus);
        }
    }

    function setWindowResizeAndScrollListener() {
        window.addEventListener('resize', debouncedOnResize);
    }

    function listenToClickOnNewOpenSearchButton() {
        domHeaderSearchBtn.forEach((btn) => {
            btn.addEventListener('click', openSearch);
        });
    }

    function listenToPremobileMenuOpen() {
        Hop.events.on(clickOnPremobileButton, setSearchInvisible);
    }

    function listenToMobileCloseSearch() {
        if (domHeaderCloseSearch) {
            domHeaderCloseSearch.addEventListener('click', closeSearch);
        }
    }

    function onSearchrequested() {
        closeSearch();
    }

    function listenToNewHeaderUserActions() {
        setWindowResizeAndScrollListener();
        listenToClickOnNewOpenSearchButton();
        listenToPremobileMenuOpen();
        hideSearchOnPreMobileMode();
        listenToMobileCloseSearch();

        if (mediaHigherThanBreakpoint('max')) {
            // If mobile
            setInputsAutompleteListener();
        }

        if (hasToBeOpenedByDefault()) {
            setSearchVisible(false);
        }

        Hop.events.on('search:refresh', onSearchrequested);
    }

    function initBackdrop() {
        if (!showBackdrop) {
            document.body.classList.add(BODY_CLASSES.noScroll);
            backdrop.classList.add('header-subheader__backdrop');
            domRoot.appendChild(backdrop);
            backdrop.addEventListener('mousedown', closeSearch);
            showBackdrop = true;
        }
    }

    function destroyBackdrop() {
        if (showBackdrop) {
            document.body.classList.remove(BODY_CLASSES.noScroll);
            domRoot.removeChild(backdrop);
            backdrop.removeEventListener('mousedown', closeSearch);
            showBackdrop = false;
        }
    }

    listenToNewHeaderUserActions();

    return function destroy() {
        domHeaderSearchBtn.forEach((btn) => {
            btn.removeEventListener('click', openSearch);
        });

        if (domHeaderCloseSearch) {
            domHeaderCloseSearch.removeEventListener('click', closeSearch);
        }

        $searchInput.removeEventListener(AWESOMEPLETE_OPEN, addFocusClassOnJobInput);
        $searchInput.removeEventListener(AWESOMEPLETE_CLOSE, removeFocusClassOnJobInput);

        window.removeEventListener('resize', debouncedOnResize);

        if (showBackdrop) {
            backdrop.removeEventListener('mousedown', closeSearch);
        }

        Hop.events.off('search:refresh', onSearchrequested);
    };
});
